
import { useState,useEffect } from "react";
import marksentryapi from '../api/gradeEntryRouter';
import loginapi from '../api/login';

import Course from '../components/GradeEntryCourseCard';

function GradeEntry({accessToken,setAccessToken,setRefreshFailed,gradeEntrySession,setGradeEntrySession,sessions,levels,semesters,marksEntryLevel,setMarksEntryLevel,marksEntrySem,setMarksEntrySem,marksEntrySub,setMarksEntrySub}) {
  const [courses,setCourses]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);

   const levelChanged=async(e)=>{
      const level = e.target.value;
    setMarksEntryLevel(level);
  }

    const semesterChanged=async(e)=>{
      const sem = e.target.value;
    setMarksEntrySem(sem);
  }
  
    const subChanged=async(e)=>{
      const sub = e.target.value.toUpperCase();
    setMarksEntrySub(sub);
  }

  useEffect(()=>{
    const fetchAT=async ()=>{
      try{       
        setIsAppLoaded(false);
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/getAllFormFillupCourses',{session:gradeEntrySession,status:'gradecomputation'},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setCourses(response.data.courseDetails); 
        setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPositionge");
  
          if (mainElement && scrollPosition) {
             mainElement.scrollTo({
      top: parseInt(scrollPosition, 10),
      behavior: 'smooth'  // 👈 this makes it smooth
    }); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100);
        //alert(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/getAllFormFillupCourses',{session:gradeEntrySession,status:'gradecomputation'},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data.courseDetails); 
                        setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPositionge");
  
          if (mainElement && scrollPosition) {
             mainElement.scrollTo({
      top: parseInt(scrollPosition, 10),
      behavior: 'smooth'  // 👈 this makes it smooth
    }); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100);
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[gradeEntrySession]);
  
  
  const sessionChanged = async (e) => {
    const session = e.target.value;
    setGradeEntrySession(session);

window.scrollTo({ top: 0, behavior: "smooth" });
  // Store current scroll position of <main> in sessionStorage
  const mainElement = document.querySelector("main");
  if (mainElement) {
    sessionStorage.setItem("scrollPositionge", mainElement.scrollTop);
  }
  };


  const filteredCourses = (courses || [])
  .filter(course => marksEntryLevel === "" || course.level === marksEntryLevel)
  .filter(course => marksEntrySem === "" || course.semester == marksEntrySem)
  .filter(course => marksEntrySub === "" || course.code.startsWith(marksEntrySub));

    return (
      <main>
        <div className="flex flex-col items-center">
          <div className="text-center mb-4">
            <h1 className="text-2xl font-bold text-gray-800">EXAM GRADE COMPUTATION</h1>
             <p className="text-center">Select Exam session</p>
            <select
        value={gradeEntrySession}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>
            <div className="flex flex-col justify-center items-center w-full">
  {isAppLoaded ? (
    courses.length > 0 ? (
      <>
        {/* This is the div that shows before the course list */}
        <div className="w-full border-b  grid grid-cols-[1fr_1fr_1fr] gap-1 p-1 text-center bg-gray-300">
          <div className="w-full flex flex-col justify-center items-center p-2">
            <label>LEVEL</label>
          
           <select
        value={marksEntryLevel}
        onChange={(e) => levelChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
      >
        <option value="">-- Choose a Level --</option>
        {levels.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>

          </div>


           <div className="w-full flex flex-col justify-center items-center p-2">
            <label>SEMESTER</label>
          
           <select
        value={marksEntrySem}
        onChange={(e) => semesterChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
      >
        <option value="">-- Choose a Sem --</option>
        {semesters.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>

          </div>
<div className="w-full flex flex-col justify-center items-center p-2">
            <label>DEPT CODE</label>
          <input
 value={marksEntrySub}
        onChange={(e) => subChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
        placeholder="E.g. ZOO BEN ASM ..."
          />
          

          </div>
          
        </div>


  <div className="flex flex-col items-center justify-center">
       
       <p className="text-center  p-1 m-2"><span className="font-bold">{filteredCourses.length} </span> courses match your filter</p>
         <div className="flex flex-wrap justify-center items-start gap-4 w-full min-h-[500px] p-2 mt-4">
{filteredCourses.map(course => (
  <Course key={course.code} course={course} session={gradeEntrySession} />
))}</div></div>
      </>
    ) : (
      <p>No courses available.</p>
    )
  ) : (
    <p>Please wait...</p>
  )}
</div>
        </div>

     
      </main>
    )
  }
  
  export default GradeEntry